import { Navbar } from '../../components/feature/Navbar';
import { Hero } from './components/Hero';
import { TrustBar } from '../../components/feature/TrustBar';
import { Services } from './components/Services';
import { Portfolio } from './components/Portfolio';
import { AIAnswerBlock } from '../../components/feature/AIAnswerBlock';
import { MidCTABanner } from '../../components/feature/MidCTABanner';
import { Process } from './components/Process';
import { WhyChooseUs } from './components/WhyChooseUs';
import { ServiceAreas } from '../../components/feature/ServiceAreas';
import { Testimonials } from './components/Testimonials';
import { FAQ } from '../../components/feature/FAQ';
import { SpecialOffer } from './components/SpecialOffer';
import { QuoteForm } from './components/QuoteForm';
import { Footer } from '../../components/feature/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen">
      {/* 1. Navbar */}
      <Navbar />
      {/* 2. Hero — CTA #1 */}
      <Hero />
      {/* 3. Trust Bar */}
      <TrustBar />
      {/* 4. Services Overview — CTA #2 (inline) */}
      <Services />
      {/* 5. Portfolio / Featured Work */}
      <Portfolio />
      {/* 6. AI Answer Block */}
      <AIAnswerBlock context="home" />
      {/* Mid-page CTA Banner — CTA #3 */}
      <MidCTABanner />
      {/* 7. Process */}
      <Process />
      {/* 8. Why Choose Us — inline CTA #4 */}
      <WhyChooseUs />
      {/* 9. Service Areas */}
      <ServiceAreas />
      {/* 10. Testimonials — CTA #5 near testimonials */}
      <Testimonials />
      {/* 11. FAQ */}
      <FAQ context="home" />
      {/* 12. Special Offer — CTA #6 */}
      <SpecialOffer />
      {/* 13. Final CTA / Quote Form — CTA #7 */}
      <QuoteForm />
      {/* Footer */}
      <Footer />
    </div>
  );
}
